import ECOMemberPasses from '@/views/integrations/ECOMember/Passes.vue'

export const ecoMemberPassRoutes = {
  path: '/integrations/eco-member-pass/:passId/apple',
  name: 'integrationEcoMemberPass',
  meta: { requiresAuth: false },
  component: ECOMemberPasses,
  props: true,
}
